import Dealer from './Dealer';

export default Dealer;
